import { useGetEmployeeWorkRulesQuery } from '../gql/graphql.generated';
import { defaultStaffSettings } from '../settings/systemSettings.types';

export function useWorkRules(employeeId: string) {
  const [{ data }, refetch] = useGetEmployeeWorkRulesQuery({
    variables: { employeeIds: [employeeId] }
  });

  const rules = data?.workRulesByEmployeeIds?.[0];

  return {
    rules: {
      minMonthlyHours: rules?.minHoursPerMonth ?? defaultStaffSettings.minMonthlyHours,
      maxMonthlyHours: rules?.maxHoursPerMonth ?? defaultStaffSettings.maxMonthlyHours,
      minWeeklyHours: rules?.minHoursPerWeek ?? defaultStaffSettings.minWeeklyHours,
      maxWeeklyHours: rules?.maxHoursPerWeek ?? defaultStaffSettings.maxWeeklyHours
    },
    refetch
  };
}
